import React from 'react';

import type { SaveListItem } from '../../../../types/save-types.js';

import { frontendConfig } from '../../../../../core/system/config/frontend.server.js';

type Props = {
  handleOnClick: (groupItem: SaveListItem) => void;
  isSaved: boolean;
  item: SaveListItem;
  isFact?: boolean;
};

const SaveButton: React.FC<Props> = ({
  handleOnClick,
  isSaved,
  item,
  isFact,
}) => {
  const heartIconLink = `${
    frontendConfig.cdnUrlInternal
  }/vink/images/icons/bookmark${isSaved ? '-saved' : '-bold'}.svg`;

  const classNames = ['save-text', isSaved ? 'bold' : ''].join(' ');
  const saveStatus = isSaved ? 'Lagret' : isFact ? 'Lagre saken' : 'Lagre';

  return (
    <button className="save" onClick={() => handleOnClick(item)}>
      <span className={classNames}>{saveStatus}</span>
      <img src={heartIconLink} alt="lagre" />
    </button>
  );
};

export default SaveButton;
